/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-14 09:59:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-07 09:22:28
 * @FilePath: \qcloud-web-pc-4.0\src\router\lang\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const documentTitle = {
  home: 'OriginQ Cloud',
  qhComputing: 'Hybrid Quantum | OriginQ Cloud',
  user_knowledge: 'Starter | OriginQ Cloud',
  user_student: 'Student | OriginQ Cloud',
  user_company: 'Enterprise | OriginQ Cloud',
  user_developer: 'Developer | OriginQ Cloud',
  user_educator: 'Educator | OriginQ Cloud',
  quantumVm_introduce: 'Introduction to logic gate | OriginQ Cloud',
  quantumVm: 'Graphical Programming | Workbentch | OriginQ Cloud',
  services: 'Computing Services | Workbentch | OriginQ Cloud',
  dashboard: 'Dashboard | Workbentch | OriginQ Cloud',
  login: 'Login/Register | OriginQ Cloud',
  register: 'Register | OriginQ Cloud',
  ntpass: 'Forgot Password | OriginQ Cloud',
  JupyterTask: 'Jupyter | Workbentch | OriginQ Cloud',
  calculateTask: 'Caculation Task | Workbentch | OriginQ Cloud',
  estimateTask: 'Price Estimator | Workbentch | OriginQ Cloud',
  application: 'Application Center | Workbentch | OriginQ Cloud',
  qPanda: 'QPanda | Workbentch | OriginQ Cloud',
  vqnet: 'VQNET | Workbentch | OriginQ Cloud',
  accessMag: '',
  ide: 'Cloud IDE | Workbentch | OriginQ Cloud',
  pay: 'Expenses | Workbentch | OriginQ Cloud',
  resource: 'Computing Resources | Workbentch | OriginQ Cloud',
  expenseCenter: 'Expenses | Workbentch | OriginQ Cloud',
  chemiq: 'Biochemical Solutions | OriginQ Cloud',
  finance: 'Quantum Finance Solutions | OriginQ Cloud',
  educate: 'Quantum Computing Education | OriginQ Cloud',
  bigData: 'Big Data | OriginQ Cloud',
  power: 'Power Industry Solution | OriginQ Cloud',
  ai: 'Artificial Intelligence Solution | OriginQ Cloud',
  engineering: 'A Solution to Engineering Design | OriginQ Cloud',
  security: 'Information Security Solution | OriginQ Cloud',
  hardware: 'Hardware Products | OriginQ Cloud',
  softCenter: 'Quantum Software | OriginQ Cloud',
  documentCenter: 'Document Center | OriginQ Cloud',
  SuperQuantum:
    'Wuyuan Series Superconducting Quantum Computer | OriginQ Cloud',
  userFeedback: 'User Feedback | OriginQ Cloud',
  workOrder: 'Work Order | OriginQ Cloud',
  message: 'Message Center | OriginQ Cloud',
  chemistryIntroduce: 'ChemiQ | OriginQ Cloud',
  chemistryTrial: 'Trial Application for ChemiQ | OriginQ Cloud',
  QCFD: 'QCFD | OriginQ Cloud',
  copyrightWord: 'All Rights Reserved | OriginQ Cloud',
  financeIndex: '量子金融赛道班 | OriginQ Cloud',
  PilotOS: 'Quantum Software | OriginQ Cloud',
  activities: '运营活动 | 本源量子云',

  OriginRockEncoder:'Origin Rock — PQC Database Encryption Machine',
  OriginRockCryptocard:'Origin Rock — Post Quantum Cryptocard',
  OriginRockModule:'Origin Rock — PQC Software Cryptographic Module',
  verify: '服务号登录/注册 - 本源量子云',
};
export default documentTitle;
